import React from 'react';
import './enCoursCommands.css';

const EnCoursCommands = ({
  index,
  shipment_number,
  picked_up,
  onMarkAsPickedUp,
  onMarkAsDelivered,
  onClose,
}) => {
  const handleMarkAsPickedUp = () => {
    onMarkAsPickedUp(index, true);
  };

  const handleMarkAsNotPickedUp = () => {
    onMarkAsPickedUp(index, false);
  };

  const handleMarkAsDelivered = () => {
    onMarkAsDelivered(index);
  };

  return (
    <div className="overlay">
      <div className="en-cours-commands-content">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <p>Dossier {shipment_number}</p>
        <div className="en-cours-commands-buttons">
          {picked_up && (
            <button type="button" onClick={handleMarkAsNotPickedUp}>
              Non enlevé
            </button>
          )}
          {!picked_up && (
            <button type="button" onClick={handleMarkAsPickedUp}>
              Enlevé
            </button>
          )}
          <button type="button" onClick={handleMarkAsDelivered}>
            Basculer vers livré
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnCoursCommands;
